module.exports = __webpack_public_path__ + "fonts/b8e906a1-f5e8-4bf1-8e80-82c646ca4d5f.b8d9f48.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/b8e906a1-f5e8-4bf1-8e80-82c646ca4d5f.woff
// module id = 189
// module chunks = 245 246